import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getOrgOverride, meApi, setOrgOverride } from '@/api/client';

/**
 * The orgs this user may act in (#847): their own, or every org for a
 * superuser. One cache entry for the header menu and the org-required gate.
 */
export function useMyOrganizations(enabled: boolean) {
  return useQuery({
    queryKey: ['my-organizations'],
    queryFn: () => meApi.organizations(),
    enabled,
    staleTime: 60_000,
  });
}

/**
 * The org switcher's pick and how to change it (#847, #1149). Shared by the
 * header's org menu and the org-required gate so both switch the same way:
 * persist the override, then reload so every query refetches in the new org.
 * `null` is "All Organizations" (superusers only).
 */
export function useOrgSwitch() {
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(getOrgOverride());

  const switchOrg = useCallback((orgId: string | null) => {
    setSelectedOrgId(orgId);
    setOrgOverride(orgId);
    // Reload the page data with the new org context
    window.location.reload();
  }, []);

  return { selectedOrgId, switchOrg };
}
